module.exports = __webpack_public_path__ + "static/media/49.c0b6b546.webp";